import { useDirectory } from '@/stores/directory.js'
import { listRecords } from '@/lib/records.js'
import { ENTITIES } from '@/lib/entities.js'
import { entityLabel } from '@/lib/labels.js'
import { fold } from '@addictivegroup/addictive-offline'

/**
 * "@" suggestions (D-44), for addictive-richtext's suggestionMenu: people first, then records. A
 * mention's id is "<entity>:<uuid>", the form Core's MentionService reads.
 */
export async function mentionItems(query) {
  const directory = useDirectory()
  await directory.load().catch(() => null)
  const q = fold(query)
  const people = directory.users
    .filter((u) => !q || fold(u.label).includes(q))
    .slice(0, 6)
    .map((u) => ({ id: `user:${u.uuid}`, label: u.label, icon: 'fa-user', hint: '' }))
  if (query.length < 2) return people
  const records = []
  for (const entity of ['account', 'contact', 'opportunity', 'lead', 'competitor']) {
    try {
      const result = await listRecords(entity, { filter: { q: query }, page: { size: 3 } })
      for (const r of result.data) records.push({ id: `${entity}:${r.uuid}`, label: r.label, icon: ENTITIES[entity].icon, hint: entityLabel(entity) })
    } catch {
      // a failed lookup only narrows the suggestions
    }
  }
  return [...people, ...records].slice(0, 12)
}
